module.exports = __webpack_public_path__ + "img/snav_icon_7.d4010274.png";